<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc"><a href="#/c01">December 29, 2021, 8:15 p.m.</a></p>
<p class="part"><a href="#/c003">Mac</a></p>
<p class="toc"><a href="#/c02">1</a></p>
<p class="toc"><a href="#/c03">December 29, 2021, 8:30 p.m.</a></p>
<p class="part"><a href="#/c006">Gwen</a></p>
<p class="toc"><a href="#/c04">2</a></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">December 29, 2021, 8:45 p.m.</span></p>
<p class="part"><span href="#/c009" title="Link target outside of Sample">The Program</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">3</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">4</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">5</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">6</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">7</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">December 30, 2021, 1:27 a.m.</span></p>
<p class="part"><span href="#/c016" title="Link target outside of Sample">Oh, Fools</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">8</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">9</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">December 30, 2021, 2:01 a.m.</span></p>
<p class="part"><span href="#/c020" title="Link target outside of Sample">Bad Habits</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">10</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">December 30, 2021, 2:17 a.m.</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">11</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">12</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">December 30, 2021, 2:40 a.m.</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">13</span></p>
<p class="part"><span href="#/c027" title="Link target outside of Sample">Claire</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">14</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">December 30, 2021, 2:59 a.m.</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">15</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">December 30, 2021, 3:07 a.m.</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">16</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">December 29, 2021, 3:45 a.m.</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Read More from Amy Gentry</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b784b35a